import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import styles from './Error.styles';
const useStyles = makeStyles(styles);

const ErrorMessage = ({ message }) => {
  const classes = useStyles();
  return <Typography className={classes.errorMessage}>{message}</Typography>;
};
ErrorMessage.defaultProps = {};
ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
